// Auto-generated index of all Canvas components
import Canvas_Circles from "./canvas_components/Canvas_Circles.jsx";
import Canvas_clearRect from "./canvas_components/Canvas_clearRect.jsx";
import Canvas_Clipping from "./canvas_components/Canvas_Clipping.jsx";
import Canvas_Compositing from "./canvas_components/Canvas_Compositing.jsx";
import Canvas_Coordinates from "./canvas_components/Canvas_Coordinates.jsx";
import Canvas_Curves from "./canvas_components/Canvas_Curves.jsx";
import Canvas_Drawing from "./canvas_components/Canvas_Drawing.jsx";
import Canvas_Examples from "./canvas_components/Canvas_Examples.jsx";
import Canvas_Fill_and_Stroke from "./canvas_components/Canvas_Fill_and_Stroke.jsx";
import Canvas_Images from "./canvas_components/Canvas_Images.jsx";
import Canvas_Intro from "./canvas_components/Canvas_Intro.jsx";
import Canvas_Linear_Gradient from "./canvas_components/Canvas_Linear_Gradient.jsx";
import Canvas_Lines from "./canvas_components/Canvas_Lines.jsx";
import Canvas_Radial_Gradient from "./canvas_components/Canvas_Radial_Gradient.jsx";
import Canvas_Rectangles from "./canvas_components/Canvas_Rectangles.jsx";
import Canvas_Shadows from "./canvas_components/Canvas_Shadows.jsx";
import Canvas_Shapes from "./canvas_components/Canvas_Shapes.jsx";
import Canvas_Text from "./canvas_components/Canvas_Text.jsx";
import Canvas_Text_Alignment from "./canvas_components/Canvas_Text_Alignment.jsx";
import Canvas_Text_Color from "./canvas_components/Canvas_Text_Color.jsx";
import Canvas_Transformations from "./canvas_components/Canvas_Transformations.jsx";
import Clock_Face from "./canvas_components/Clock_Face.jsx";
import Clock_Hands from "./canvas_components/Clock_Hands.jsx";
import Clock_Intro from "./canvas_components/Clock_Intro.jsx";
import Clock_Numbers from "./canvas_components/Clock_Numbers.jsx";
import Clock_Start from "./canvas_components/Clock_Start.jsx";
import Plot_Canvas from "./canvas_components/Plot_Canvas.jsx";
import Plot_Chartjs from "./canvas_components/Plot_Chartjs.jsx";
import Plot_D3js from "./canvas_components/Plot_D3js.jsx";
import Plot_Google from "./canvas_components/Plot_Google.jsx";
import Plot_Graphics from "./canvas_components/Plot_Graphics.jsx";
import Plot_Plotly from "./canvas_components/Plot_Plotly.jsx";

const canvasComponentsMap = {
  "<Canvas_Circles />": Canvas_Circles,
  "<Canvas_clearRect />": Canvas_clearRect,
  "<Canvas_Clipping />": Canvas_Clipping,
  "<Canvas_Compositing />": Canvas_Compositing,
  "<Canvas_Coordinates />": Canvas_Coordinates,
  "<Canvas_Curves />": Canvas_Curves,
  "<Canvas_Drawing />": Canvas_Drawing,
  "<Canvas_Examples />": Canvas_Examples,
  "<Canvas_Fill_and_Stroke />": Canvas_Fill_and_Stroke,
  "<Canvas_Images />": Canvas_Images,
  "<Canvas_Intro />": Canvas_Intro,
  "<Canvas_Linear_Gradient />": Canvas_Linear_Gradient,
  "<Canvas_Lines />": Canvas_Lines,
  "<Canvas_Radial_Gradient />": Canvas_Radial_Gradient,
  "<Canvas_Rectangles />": Canvas_Rectangles,
  "<Canvas_Shadows />": Canvas_Shadows,
  "<Canvas_Shapes />": Canvas_Shapes,
  "<Canvas_Text />": Canvas_Text,
  "<Canvas_Text_Alignment />": Canvas_Text_Alignment,
  "<Canvas_Text_Color />": Canvas_Text_Color,
  "<Canvas_Transformations />": Canvas_Transformations,
  "<Clock_Face />": Clock_Face,
  "<Clock_Hands />": Clock_Hands,
  "<Clock_Intro />": Clock_Intro,
  "<Clock_Numbers />": Clock_Numbers,
  "<Clock_Start />": Clock_Start,
  "<Plot_Canvas />": Plot_Canvas,
  "<Plot_Chartjs />": Plot_Chartjs,
  "<Plot_D3js />": Plot_D3js,
  "<Plot_Google />": Plot_Google,
  "<Plot_Graphics />": Plot_Graphics,
  "<Plot_Plotly />": Plot_Plotly,
};

export default canvasComponentsMap;
